import { Action } from '@ngrx/store';
import { providerManagements } from '@app/models/providerManagements';

export enum ManagementActionTypes {
  Load = '[Management] Load',
  LoadSuccess = '[Management] Load Success',
  LoadFail = '[Management] Load Fail',
  Select = '[Management] Select',
  Delete = '[Management] Delete',
  DeleteSuccess = '[Management] Delete success',
  DeleteFail = '[Management] Delete fail',
  Create = '[Management] Create',
  CreateSuccess = '[Management] Create success',
  CreateFail = '[Management] Create fail',
  Update = '[Management] Update',
  UpdateSuccess = '[Management] Update success',
  UpdateFail = '[Management] Update fail',
  AddResponsable = '[Management] Add Responsable',
  AddResponsableSuccess = '[Management] Add Responsable Success',
  AddResponsableFail = '[Management] Add Responsable Fail',
  DeleteResponsable = '[Management] delete Management responsable',
  DeleteResponsableSuccess = '[Management] delete Management responsable success',
  DeleteResponsableFail = '[Management] delete Management responsable fail'
}

export class Load implements Action {
  readonly type = ManagementActionTypes.Load;
  constructor(public followGroupId: any, public page?: any, public mode?: string) {}
}

export class LoadSuccess implements Action {
  readonly type = ManagementActionTypes.LoadSuccess;
  constructor(public management: providerManagements[], public mode?: string) {}
}

export class LoadFail implements Action {
  readonly type = ManagementActionTypes.LoadFail;
  constructor(public error: any) {}
}

export class Select implements Action {
  readonly type = ManagementActionTypes.Select;
  constructor(public id: number) {}
}

export class Delete implements Action {
  readonly type = ManagementActionTypes.Delete;
  constructor(public id: number, public mode?: string) {}
}

export class DeleteSuccess implements Action {
  readonly type = ManagementActionTypes.DeleteSuccess;
  constructor(public id: number) {}
}

export class DeleteFail implements Action {
  readonly type = ManagementActionTypes.DeleteFail;
  constructor(public error: any) {}
}

export class Create implements Action {
  readonly type = ManagementActionTypes.Create;
  constructor(public data: any, public mode?: string) {}
}

export class CreateSuccess implements Action {
  readonly type = ManagementActionTypes.CreateSuccess;
  constructor(public management: any) {}
}

export class CreateFail implements Action {
  readonly type = ManagementActionTypes.CreateFail;
  constructor(public error: any) {}
}

export class Update implements Action {
  readonly type = ManagementActionTypes.Update;
  constructor(public id: number, public data?: any) {}
}

export class UpdateSuccess implements Action {
  readonly type = ManagementActionTypes.UpdateSuccess;
  constructor(public data: any) {}
}

export class UpdateFail implements Action {
  readonly type = ManagementActionTypes.UpdateFail;
  constructor(public error: any) {}
}

export class AddResponsable implements Action {
  readonly type = ManagementActionTypes.AddResponsable;
  constructor(public data: any) {}
}

export class AddResponsableSuccess implements Action {
  readonly type = ManagementActionTypes.AddResponsableSuccess;
  constructor(public data: any) {}
}

export class AddResponsableFail implements Action {
  readonly type = ManagementActionTypes.AddResponsableFail;
  constructor(public data: any) {}
}

export class DeleteResponsable implements Action {
  readonly type = ManagementActionTypes.DeleteResponsable;
  constructor(public id: number, public data: any) {}
}

export class DeleteResponsableSuccess implements Action {
  readonly type = ManagementActionTypes.DeleteResponsableSuccess;
  constructor(public data: any) {}
}

export class DeleteResponsableFail implements Action {
  readonly type = ManagementActionTypes.DeleteResponsableFail;
  constructor(public data: any) {}
}

export type ManangementActionsUnion = 
Load | 
LoadSuccess |
LoadFail | 
Select | 
Delete |
DeleteSuccess |
DeleteFail |
Create |
CreateSuccess |
CreateFail |
Update |
UpdateSuccess |
UpdateFail |
AddResponsable |
AddResponsableSuccess | 
AddResponsableFail | 
DeleteResponsable  | 
DeleteResponsableSuccess  | 
DeleteResponsableFail;
